import Body from "./body";
import Box from "./box";
import CardRoot from "./card";
import { Badge, Paragraph, Title } from "./texts";
import Thumbnail from "./thumbnail";

const CardUI = Object.assign(CardRoot, {
  Body,
  Box,
  Title,
  Badge,
  Paragraph,
  Thumbnail
})

export default CardUI
